import Model from './Model'

export default class User extends Model {
  resource() {
    return 'users'
  }

  isVerified() {
    return this.email_verified
  }

  get roleText() {
    if (!this.roles || !this.roles.length) return ''
    let roles = null

    /**
     * Special case:
     * Change `sparky` to `contractor`
     */
    const getSparkyLabel = r =>
      r.toUpperCase() === 'SITE_SPARKY'
        ? 'contractor'
        : r.toUpperCase() === 'SITE_HEAD_SPARKY'
        ? 'head contractor'
        : r
    if (Array.isArray(this.roles)) {
      roles = this.roles.map(role => getSparkyLabel(role)).join(' | ')
    } else {
      roles = getSparkyLabel(roles)
    }

    return (
      roles
        .toString()
        .replaceAll('_', ' ')
        /* Set to lowercase and let CSS handle the capitalization */
        .toLowerCase()
    )
  }
}
